import { FC, useEffect, useState } from 'react';

import { DateType } from '@utils/dateUtil';
import {
  Arrow,
  ErrorMessageContainer,
  ErrorMessage,
} from '@domain/hotel/styled';

import HotelBookerDatePicker from './HotelBookerDatePicker';
import { Container } from './styled';

export type DateDataTypes = {
  startDate: DateType;
  endDate: DateType;
};

type PropTypes = {
  onChange?: (data: DateDataTypes) => void;
  isSubmit?: boolean;
};

const DateSelection: FC<PropTypes> = ({
  onChange: pOnChange = (v) => v,
  isSubmit,
}) => {
  const [isFocused, setIsFocused] = useState(false);
  const [localStartDate, setLocalStartDate] = useState<DateType | null>(null);
  const [localEndDate, setLocalEndDate] = useState<DateType | null>(null);

  const onDatesChange = (dates?: {
    startDate?: DateType | null;
    endDate?: DateType | null;
  }) => {
    setLocalStartDate(dates?.startDate as DateType);
    setLocalEndDate(dates?.endDate as DateType);

    if (dates?.startDate && dates?.endDate) {
      pOnChange({ startDate: dates.startDate, endDate: dates.endDate });
    }
  };

  const handleFocus = () => {
    setIsFocused(true);
  };

  const handleBlur = () => {
    setIsFocused(false);
  };

  useEffect(() => {
    if (localEndDate) setIsFocused(true);
  }, [localEndDate]);

  return (
    <Container>
      <HotelBookerDatePicker
        dateChange={onDatesChange}
        setLocalEndDate={setLocalEndDate}
        setLocalStartDate={setLocalStartDate}
        localStartDate={localStartDate}
        localEndDate={localEndDate}
        isSubmit={isSubmit && !isFocused}
        onFocus={handleFocus}
        onBlur={handleBlur}
      />
      {!isFocused && isSubmit && !localEndDate && (
        <ErrorMessageContainer>
          <Arrow />
          <ErrorMessage>Tarih seçiniz</ErrorMessage>
        </ErrorMessageContainer>
      )}
    </Container>
  );
};

export default DateSelection;
